import { Reveal } from "./Reveal";
import { ChapterLabel } from "./ChapterLabel";
import { experience, education } from "../data/content";

export default function Experience() {
  return (
    <section id="experience" className="section-shell" data-testid="experience-section">
      <div className="container-x">
        <ChapterLabel index="03" title="Experience" />

        <div className="relative">
          {/* Vertical hairline connector */}
          <span className="absolute left-[5px] top-2 bottom-2 w-px bg-cardline hidden sm:block" aria-hidden="true" />

          <div className="space-y-14">
            {experience.map((job, i) => (
              <Reveal key={job.role} delay={Math.min(i * 0.04, 0.15)}>
                <div className="sm:pl-12 relative" data-testid={`experience-item-${i}`}>
                  <span
                    className={`hidden sm:block absolute left-0 top-2 w-[11px] h-[11px] rounded-full border-2 ${
                      job.current ? "border-teal bg-teal" : "border-cardline bg-canvas"
                    }`}
                    aria-hidden="true"
                  />
                  <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                    <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-ink">
                      {job.role}
                    </h3>
                    {job.current && (
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal bg-teal-light px-2 py-0.5">
                        Current
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-faint mt-1.5 font-mono tracking-wide">
                    {job.org} · {job.dates}
                    {job.note && <span className="text-teal"> · {job.note}</span>}
                  </p>
                  <ul className="mt-5 space-y-2.5 max-w-3xl">
                    {job.bullets.map((b, j) => (
                      <li key={j} className="flex gap-3 text-base text-body leading-relaxed">
                        <span className="mt-[0.65em] w-3 h-px bg-teal/60 shrink-0" aria-hidden="true" />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Education — quiet footer of the timeline */}
        <Reveal delay={0.1}>
          <div className="mt-20 pt-10 border-t border-hairline" data-testid="education-block">
            <p className="font-mono text-xs uppercase tracking-[0.28em] text-faint mb-6">Education</p>
            <div className="grid sm:grid-cols-2 gap-6">
              {education.map((e) => (
                <div key={e.degree} className="bg-panel border border-hairline p-6">
                  <p className="font-display text-lg font-semibold text-ink">{e.degree}</p>
                  <p className="text-sm text-body mt-1">
                    {e.school} · {e.year}
                  </p>
                  {e.note && <p className="text-sm text-teal mt-2">{e.note}</p>}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
